import React, { useEffect, useRef, useState } from "react";
import { get } from "lodash";
import { useOutletContext } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

import Hover from "./Hover";
import Slider from '../../components/Slider';

import style from "./style.module.css";

let timer = 0;
export default function ContentGrid(props) {
    const { 
        wrap = 0, 
        items = [],
        autoplay = false, 
        Component, 
        delay = 5000,
        initialPerView = 4,
        show_hover_popup = 0,
        showDescription = 1,
        showSocialMedia = 1,
        showSlideOverflowBigScreen = 1,
        col = "col4",
        type = "",
    } = props;

    const [hoveredItem, setHoveredItem] = useState(false);
    const { winWidth } = useOutletContext() || {};

    const calculateItemsInView = () => {
        if (wrap === 1) {
            return false;
        }
    }

    useEffect(() => {
        const t = setTimeout(() => {
            calculateItemsInView();
        }, 500)
        return () => {
            clearTimeout(t);
        }
        // eslint-disable-next-line
    }, [winWidth])

    useEffect(() => {
        const handleMove = () => {
            clearTimeout(timer);
        }
        document.addEventListener('mousemove', handleMove);
        return () => {
            clearTimeout(timer);
            document.removeEventListener('mousemove', handleMove);
        }
    }, [])

    const onHover = (item, ref) => {
        if (show_hover_popup) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setHoveredItem({ ...item, itemRef: ref, type: "hover" })
            }, 1000);
        }
    }

    const swiperRef = useRef(null);
    let modules = [Pagination];
    if (autoplay === true) {
        modules.push(Autoplay);
    }

    const closeModal = () => {
        setHoveredItem(false);
    }

    return (
        <>
            {
                wrap === 1 && items.length > 0 && (
                    <div className={style.gridRow}>
                        {
                            items.map((item, index) => (
                                <Component
                                    key={`card_item_${index}`}
                                    item={item}
                                    size={col}
                                    onHover={(itemRef) => onHover(item, itemRef)}
                                    showDescription={showDescription}
                                    showSocialMedia={showSocialMedia}
                                    type={type}
                                />
                            ))
                        }
                    </div>
                )
            }
            {
                wrap === 0 && items.length > 0 && (
                    <Slider className={`gridSlide ${showSlideOverflowBigScreen === 0 ? style.hideSlideOverflowBigScreen : ""}`} swiperRef={swiperRef} autoplay={autoplay}>
                        <Swiper
                            ref={swiperRef}
                            modules={modules}
                            autoplay={{
                                delay: delay,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            className={style.gridSlider}
                            breakpoints={
                                {
                                    1400: { slidesPerView: initialPerView === 5 ? 5 : 4, spaceBetween: 16 },
                                    1280: { slidesPerView: initialPerView === 5 ? 4 : 3, spaceBetween: 16 },
                                    1024: { slidesPerView: initialPerView === 5 ? 4 : 3, spaceBetween: 16 },
                                    820: { slidesPerView: 3, spaceBetween: 16 },
                                    800: { slidesPerView: 3, spaceBetween: 16 },
                                    780: { slidesPerView: 3, spaceBetween: 8 },
                                    640: { slidesPerView: 2, spaceBetween: 8 },
                                    600: { slidesPerView: 2, spaceBetween: 8 },
                                    560: { slidesPerView: 2, spaceBetween: 8 },
                                    540: { slidesPerView: 2, spaceBetween: 8 },
                                    500: { slidesPerView: 2, spaceBetween: 8 },
                                    480: { slidesPerView: 2, spaceBetween: 8 },
                                    400: { slidesPerView: 2, spaceBetween: 8 },
                                    380: { slidesPerView: 1, spaceBetween: 8 },
                                    340: { slidesPerView: 1, spaceBetween: 8 },
                                    300: { slidesPerView: 1, spaceBetween: 8 },
                                    280: { slidesPerView: 1, spaceBetween: 8 },
                                }
                            }
                        >
                            {
                                items.map((item, index) => (
                                    <SwiperSlide key={`card_slide_item_${index}`} className={style.sliderItem}>
                                        <Component 
                                            item={item} 
                                            size={col}
                                            onHover={(itemRef) => onHover(item, itemRef)}
                                            showDescription={showDescription}
                                            showSocialMedia={showSocialMedia}
                                            type={type}
                                        />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </Slider>
                )
            }
            {
                show_hover_popup === 1 && get(hoveredItem, "type", "") === "hover" && (
                    <Hover 
                        togglePopup={() => { setHoveredItem({ ...hoveredItem, type: "moreinfo" }) }} 
                        {...hoveredItem} 
                        closeModal={closeModal} 
                    />
                )
            }
        </>
    )
}